import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

import { PrescriptionTemplate } from '../prescription-template';
import { PrescriptionTemplateService } from '../../service/prescription-template.service';

@Component({
  selector: 'mc-prescription-template-show',
  templateUrl: './prescription-template-show.component.html',
  styleUrls: ['./prescription-template-show.component.scss']
})
export class PrescriptionTemplateShowComponent implements OnInit {

  template: PrescriptionTemplate;

  constructor(
    private ptService: PrescriptionTemplateService,
    private route: ActivatedRoute,
    private location: Location,
    private notifService: ToastrService
  ) { }

  ngOnInit() {
    this.getPrescriptionTemplate();
  }

  getPrescriptionTemplate(): void {
    const id = +this.route.snapshot.paramMap.get('id');
    this.ptService.getPrescriptionTemplate(id).subscribe(
      template => this.template = template
    );
  }

  savePrescriptionTemplate(): void {
    if (this.template) {
      this.ptService.updatePrescriptionTemplate(this.template).subscribe(
        template => {
          this.notifService.success('Receita atualizada');
          this.location.back();
        },
        error => this.notifService.error(error)
      );
    }
  }

  goBack(): void {
    this.location.back();
  }
}
